import { render, staticRenderFns } from "./_FormItem.vue?vue&type=template&id=3fa3c328"
import script from "./_FormItem.vue?vue&type=script&lang=js"
export * from "./_FormItem.vue?vue&type=script&lang=js"
import style0 from "./_FormItem.vue?vue&type=style&index=0&id=3fa3c328&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports